// extracted by mini-css-extract-plugin
export var animate = "notification-module--animate--OmCg4";
export var buttonContainer = "notification-module--buttonContainer--48yoh";
export var closeContainer = "notification-module--closeContainer--TPtyi";
export var notification = "notification-module--notification--Xbixu";
export var popup = "notification-module--popup--nOJ9q";
export var visible = "notification-module--visible--daXt3";